import * as React from 'react';
import { Translate } from 'react-redux-i18n';

import { FileName } from '../styles';
import { Label, Button } from '../../styles';
import Utils from '../../../../../utils';

interface MainViewProps {
	iconName: string;
	label: string;
	isResetButtonDisplayed: boolean;
	onReplaceClick: () => void;
	onResetClick: () => void;
	isExternalLinkActive?: boolean;
	linkPanel?: React.ReactNode;
}

const MainView = ({
	iconName,
	label,
	isResetButtonDisplayed,
	onReplaceClick,
	onResetClick,
	isExternalLinkActive,
	linkPanel,
}: MainViewProps) => (
	<>
		{isExternalLinkActive && linkPanel
			? <>{linkPanel}</>
			: (
				<>
					<Label value="messages.your_file" />
					<FileName>
						{Utils.getSvgIcon(iconName)}
						<Translate value={label} />
					</FileName>
				</>
			)
		}
		{isResetButtonDisplayed &&
			<Button
				type="button"
				onClick={onResetClick}
			>
				<Translate value="messages.reset_to_default" />
			</Button>
		}
		<Button
			type="button"
			onClick={onReplaceClick}
		>
			<Translate value="messages.replace" />
		</Button>
	</>
);

export default MainView;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/ResourcePanel/MainView/index.tsx